<template>
  <div>
    <div class="table-responsive">
      <div
        id="zero_config_wrapper"
        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
      >
        <div class="row" style="height: 15rem; overflow: auto">
          <div class="col-sm-12">
            <table id="zero_config" class="table">
              <thead class="data-table-bg">
                <tr>
                  <th
                    :key="index"
                    v-for="(column, index) in tableColumns"
                    style="cursor: pointer; text-align: left"
                  >
                    {{ column[0] }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="dropOffs.length">
                <template v-for="(data, index) in dropOffs">
                  <tr
                    style="cursor: pointer; text-align: left"
                    :class="{ 'data-table-bg': index % 2 !== 0 }"
                    :key="index"
                    v-if="data.contact.name"
                  >
                    <td>{{ data.contact.name }}</td>
                    <td>{{ data.contact.email }}</td>
                    <td>{{ data.contact.phoneNumber }}</td>
                    <td>{{ data.items.length }}</td>
                    <td>{{ data.contact.address }}</td>
                    <td>
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          class="cursor-pointer"
                          @click="toggleAccordion(index)"
                        >
                          <DropdownIcon
                            v-if="index === expandedIndex"
                            style="transform: rotate(180deg)"
                          />
                          <DropdownIcon v-else />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click="$emit('edit_dropOff', data, index)"
                        >
                          <IconEdit />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click="$emit('delete_dropOff', index)"
                        >
                          <IconDeleteUser />
                        </span>
                      </div>
                    </td>
                  </tr>
                  <transition
                    name="slide-fade"
                    :key="'accordion-' + index"
                    v-if="data.items.length"
                  >
                    <tr v-if="expandedIndex === index">
                      <td colspan="6" class="px-0 pt-0">
                        <table class="nested-table w-100">
                          <thead class="data-table-bg">
                            <tr>
                              <th
                                :key="index"
                                v-for="(column, index) in itemsTableColumns"
                                style="cursor: pointer; text-align: left"
                              >
                                {{ column[0] }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="data.items.length">
                            <tr
                              :key="`item-${itemIndex}`"
                              v-for="(item, itemIndex) in data.items"
                              style="cursor: pointer; text-align: left"
                            >
                              <td>
                                {{ formatDate(data.deliveryDate) }}
                              </td>
                              <td>{{ item.name }}</td>
                              <td>{{ item.weight }}</td>
                              <td>{{ item.quantity }}</td>
                              <!-- <td>{{ item.logisticsType }}</td> -->
                              <td>{{ formattedTotalPrice(item.price) }}</td>
                              <td>{{ item.description }}</td>
                              <td>
                                {{ item.dataLoggerSettings.minTemperature }}
                              </td>
                              <td>
                                {{ item.dataLoggerSettings.maxTemperature }}
                              </td>
                              <td>
                                {{ item.dataLoggerSettings.minHumidity }}
                              </td>
                              <td>
                                {{ item.dataLoggerSettings.maxHumidity }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </transition>
                </template>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="height: 8rem"
                    >
                      <div
                        class="cursor-pointer d-flex justify-content-center align-items-center"
                        @click="$emit('showAddDropOffModal')"
                      >
                        <icon-circle-add class="mr-2" />
                        <span class="text-primary">
                          {{ $t("add_dropoff") }}</span
                        >
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DropdownIcon from "../../../components/Iconsvg/DropdownIcon.vue";
import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";
import IconDeleteUser from "../../../components/Iconsvg/IconDeleteUser.vue";
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";
import { currenciesFormat } from "../../../utils/constants";

export default {
  components: { IconCircleAdd, IconDeleteUser, IconEdit, DropdownIcon },
  name: "DropOffStep",
  props: {
    dropOffs: Array,
    currency: String,
  },
  computed: {
    tableColumns() {
      return [
        [this.$t("reciever_name"), "column1"],
        [this.$t("emailModal.emailAddress"), "column2"],
        [this.$t("phone_num"), "column3"],
        [this.$t("num_of_items"), "column4"],
        [this.$t("address"), "column5"],
        [this.$t("actions"), "column6"],
      ];
    },
    itemsTableColumns() {
      return [
        [this.$t("Date & Time"), "date"],
        [this.$t("Name"), "name"],
        [this.$t("Wgt"), "weight"],
        [this.$t("Qty"), "quantity"],
        // [this.$t("Logistics"), "logistics"],
        [this.$t("price"), "price"],
        [this.$t("description"), "description"],
        ["Min Temp", "minTemp"],
        ["Max Temp", "maxTemp"],
        ["Min Humd", "minHumd"],
        ["Max Humd", "maxHumd"],
      ];
    },
  },
  data() {
    return {
      expandedIndex: null,
    };
  },
  methods: {
    toggleAccordion(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YY HH:mm");
    },
    formattedTotalPrice(amount) {
      return new Intl.NumberFormat(currenciesFormat[this.currency], {
        style: "currency",
        currency: this.currency,
      }).format(amount);
    },
  },
};
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-20px);
}
</style>
